import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { KeepInTouchRouting } from './keep-in-touch.routes';

import { UpdateDetailsComponent } from "./update-details/update.details.component";
import { KeepInTouchHomeComponent } from "./home/home.component";
import { EndTkufatRishumComponent } from "./end-tkufat-rishum/end-tkufat-rishum.component";
import { EndRishumComponent } from "./end-rishum/end-rishum.component";

@NgModule({
    imports: [KeepInTouchRouting, SharedModule],
    declarations: [
        KeepInTouchHomeComponent,
        UpdateDetailsComponent,
        EndTkufatRishumComponent,
        EndRishumComponent
    ],
})

export class KeepInTouchModule { }
